/*
 * @Author: 孙福聪
 * @Date: 2019-01-16 16:02:53
 * @Last Modified by: 史和祥
 * @Last Modified time: 2019-03-13 15:32:44
 */
import Vue from "vue";
// 富文本编辑器样式
import VueQuillEditor from "vue-quill-editor"; // use
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import vueToTop from "to-top-vue";
import VueDND from "awe-dnd";
import Localstorage from "zx-local";
import "babel-polyfill";
import Es6Promise from "es6-promise";
import router from "./router";
import App from "./App.vue";
import store from "./store/store";
import "./plugins/iview.js";
import api from "./api/index";
import focusData from "./utils/focusData";
import myMixin from "./mixins/case/main.js";
import myLogo from "./mixins/logo";
import DeleteCopy from "./mixins/case/deletecopy.js";
import subjectMixin from "./mixins/case/subject.js";
import myDirective from "./directive/index";
import "./utils/getCase";
const local = new Localstorage();
local.setName("policy");
local.dispatchEventStroage();
// import "@/assets/icon/iconfont.css";
Vue.mixin(myMixin);
Vue.mixin(myLogo);
Vue.mixin(DeleteCopy);
Vue.mixin(subjectMixin); // 创建题目相关的全局函数
Vue.use(VueDND);
Vue.use(vueToTop);
Vue.use(VueQuillEditor);
focusData.getToken(); // 获取一些全局的变量
myDirective(Vue);
Vue.config.productionTip = false;
// console.sun = console.log;
console.sun = () => {};
require("es6-promise").polyfill();
Es6Promise.polyfill();
router.beforeEach((to, from, next) => {
  console.sun(to, "to");
  // ...
  if (
    sessionStorage.getItem("token") &&
    JSON.parse(sessionStorage.getItem("token")).type === "policy"
  ) {
    if (
      to.path.includes("Teacher") &&
      JSON.parse(sessionStorage.getItem("token")).role === "student"
    ) {
      router.push("/Student/home");
      return;
    }
    if (
      to.path.includes("Student") &&
      JSON.parse(sessionStorage.getItem("token")).role === "admin"
    ) {
      router.push("/Teacher/userlist");
      return;
    }
    /** 判断是否登录↑ */
    /** 判断跳转的页面是不是登陆页↓ */
    if (to.name === "login") {
      let role =
        JSON.parse(sessionStorage.getItem("token")).role !== "student"
          ? "/Teacher/userlist"
          : "/Student/home";
      if (JSON.parse(sessionStorage.getItem("token")).role === "teacher") {
        role = "/Teacher/classlist";
        router.push(role);
      }
      next(role);
    } else {
      next();
    }
  } else if (to.name === "login" || to.name === "forgetpassword" || to.name === "loginmiddle") {
    console.log("🚀 ~ router.beforeEach ~ to.name:", to.name);
    next();
  } else {
    // Vue.$Message.error("登录信息已过期");
    sessionStorage.clear();
    sessionStorage.clear();
    next("/");
  }
});
Vue.use(api);
new Vue({
  router,
  store,
  render(h) {
    return h(App);
  }
}).$mount("#app");
